import React, { useState, useEffect } from "react"
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap"
import MetaTags from "react-meta-tags"

import EnvAuditService from "services/applications/envAudit/EnvAuditService"

const envAuditService = new EnvAuditService(
  JSON.parse(localStorage.getItem("authUser"))
)

const SectorOfActivity = () => {
  const [sectors, setSectors] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [currentSector, setCurrentSector] = useState({
    name: "",
    is_active: true,
  })
  const [isEditMode, setIsEditMode] = useState(false)

  // Fetch all sectors
  useEffect(() => {
    fetchSectors()
  }, [])

  const fetchSectors = async () => {
    envAuditService.getSectorOfActivities().then(response => {
      // console.log("response from get all sectors", response)
      if (response.status) {
        setSectors(response.data)
      }
    })
  }

  // Handle form input changes
  const handleInputChange = e => {
    const { name, value } = e.target
    setCurrentSector(prev => ({
      ...prev,
      [name]: name === "is_active" ? e.target.checked : value,
    }))
  }

  // Add or update a sector
  const handleSave = async () => {
    try {
      if (isEditMode) {
        // Update sector
        // await axios.put(`${apiUrl}/${currentSector.id}`, currentSector);
        envAuditService
          .updateSectorOfActivity(currentSector.id, currentSector)
          .then(response => {
            console.log("response from updating sector", response)
          })
      } else {
        // Create new sector
        // await axios.post(apiUrl, currentSector);
        envAuditService.createSectorOfActivity(currentSector).then(response => {
          console.log("response from updating sector", response)
        })
      }
      fetchSectors()
      toggleModal()
    } catch (error) {
      console.error("Error saving sector:", error)
    }
  }

  // Delete a sector
  const handleDelete = async id => {
    try {
      // await axios.delete(`${apiUrl}/${id}`);
      envAuditService
        .deleteSectorOfActivity(currentSector.id)
        .then(response => {
          console.log("response from deleting sector", response)
        })
      fetchSectors()
    } catch (error) {
      console.error("Error deleting sector:", error)
    }
  }

  // Open modal for adding or editing
  const toggleModal = (sector = null) => {
    if (sector) {
      setCurrentSector(sector)
      setIsEditMode(true)
    } else {
      setCurrentSector({ name: "", is_active: true })
      setIsEditMode(false)
    }
    setModalOpen(!modalOpen)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>All Companies</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Sector of Activity</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active"></li>
                </ol>
              </Col>
            </Row>
          </div>

          <Button color="primary" onClick={() => toggleModal()}>
            Add Activity
          </Button>
          <Table striped className="mt-3">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Active</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sectors.map((sector, index) => (
                <tr key={sector.id}>
                  <td>{index + 1}</td>
                  <td>{sector.name}</td>
                  <td>{sector.is_active ? "Yes" : "No"}</td>
                  <td>
                    <Button
                      color="warning"
                      size="sm"
                      className="me-2"
                      onClick={() => toggleModal(sector)}
                    >
                      Edit
                    </Button>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => handleDelete(sector.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* Modal for Add/Edit */}
          <Modal isOpen={modalOpen} toggle={() => toggleModal()}>
            <ModalHeader toggle={() => toggleModal()}>
              {isEditMode ? "Edit Sector" : "Add Sector"}
            </ModalHeader>
            <ModalBody>
              <Form>
                <FormGroup>
                  <Label for="name">Name</Label>
                  <Input
                    id="name"
                    name="name"
                    type="text"
                    value={currentSector.name}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      name="is_active"
                      checked={currentSector.is_active}
                      onChange={handleInputChange}
                    />
                    Active
                  </Label>
                </FormGroup>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={handleSave}>
                Save
              </Button>
              <Button color="secondary" onClick={() => toggleModal()}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SectorOfActivity
